import {Fill, Stroke, Style, Text} from "ol/style";
import {
    importanceRegionColorList,
    sentimentRegionColorList
} from "@/components/MapPage/MainMap/constant";

export const initializeMapRating = (map, regionRating) => {
    const layers = map.getLayers();
    let ratingSource;

    // Поиск слоя с регионами
    layers.forEach((layer) => {
        if (layer.getSource().get("name") === "map") ratingSource = layer.getSource();
    });

    if (regionRating === null) {
        clearMapRating(ratingSource);
        return false;
    }

    ratingSource.getFeatures().forEach((feature) => {
        const activeFilterTypeOption = localStorage.getItem("avalMapActiveFilterType") || "importance";
        const currentRegionRating = regionRating.find((rating) => rating.locationId === feature.get("id"));
        const colorId = currentRegionRating?.rating ?? "undefined";
        
        const color = activeFilterTypeOption === "sentiment"
            ? sentimentRegionColorList[colorId.toString()]
            : importanceRegionColorList[colorId.toString()];

        console.log('REGION COLOR IS:', color, colorId)

        // Переписываем дефолтный стиль региона, добавляя заливку
        feature.setStyle(
            new Style({
                stroke: new Stroke({
                    color: "#585B5C",
                    width: 1
                }),
                fill: new Fill({
                    color,
                }),
                text: new Text({
                    font: "bold 12px Roboto,sans-serif",
                    fill: new Fill({ color: "#000" }),
                    text: feature.get("name")
                })
            })
        );
    });
};

const clearMapRating = (ratingSource) => {
    const activeFilterTypeOption = localStorage.getItem("avalMapActiveFilterType") || "importance";
    const colorId = "undefined";

    const color = activeFilterTypeOption === "sentiment"
        ? sentimentRegionColorList[colorId.toString()]
        : importanceRegionColorList[colorId.toString()];

    ratingSource.getFeatures().forEach((feature) => {
        feature.setStyle(
            new Style({
                stroke: new Stroke({
                    color: "#585B5C",
                    width: 1
                }),
                fill: new Fill({
                    color: color,
                }),
                text: new Text({
                    font: "bold 12px fangsong,sans-serif",
                    fill: new Fill({ color: "black" }),
                    text: feature.get("name")
                })
            })
        );
    });
};
